/**
 * Button in the menu to
 */
const DestructurePlugin = () => {
  return {
    onConstruct(editor, next) {
      editor.registerHoverMenuButton('spacer', {
        type: 'spacer',
        show: node => {
          return node.type !== 'lineGroup'
        }
      })
      editor.registerHoverMenuButton('removeFormat', {
        label: 'Remove Format',
        icon: 'ion-ios-close-outline',
        type: 'destructure',
        before: 'spacer',
        show: node => {
          return node.type !== 'lineGroup'
        }
      })
      return next()
    },
    commands: {
      removeFormat(editor, node) {
        editor.blur().destructureElement(node)
      }
    }
  }
}

export default DestructurePlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/DestructurePlugin.js